var botStickyTimeout;
class StickyAddToCart extends HTMLElement {
	constructor() {
		super();
		this.anchor = document.getElementById('product-add-to-cart') || this.closest('.productView');
        this.shadowBox = document.getElementById('shadow-box');
        this.mark = document.querySelector('footer');
        this.inner = this.querySelector('.sticky-inner');
		this.toogle = this.querySelector('[data-toogle-content-sticky]');
        this.toogle?.addEventListener('click', this.toggleEvent.bind(this));
        this.botStickyTimeout = null;
	}

	connectedCallback(){
		this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
	}

	disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
        let observer = new IntersectionObserver((entries, observer) => { 
            entries.forEach(entry => {
                if(entry.isIntersecting){
                    if(entry.boundingClientRect.top < 0 && window.innerWidth > 750) {//针对ipone se做底部加购按钮特殊处理,详情页底部悬浮加购按钮
                        requestAnimationFrame(this.hide.bind(this));
                    }
                    
                    entry.target.src = entry.target.dataset.src;
                    observer.unobserve(entry.target);
                } else {
                    if (this.anchor && this.check(this.anchor, 100)) {
                        requestAnimationFrame(this.show.bind(this));

                        if(window.innerWidth > 550) {
                            if(document.body.classList.contains('scroll-up')){
                                let height = document.querySelector('.header-group').offsetHeight;

                                this.style.top = `${height}px`;
                            } else if(document.body.classList.contains('scroll-down')) {
                                this.style.top = 0;
                            }
                        } else {
                            if(document.querySelector('#Toolbar-halo-toolbar-mobile')) {
                                let height = document.querySelector('#Toolbar-halo-toolbar-mobile').offsetHeight;

                                this.style.bottom = `${height}px`;
                            }
                        }
                    } else{
                        // console.log('not intersecting走到了这里');
                        requestAnimationFrame(this.hide.bind(this));
                    }
                }
            });
        }, {
            threshold: [0, 1]
        });

        observer.observe(this.mark);
    }

    check(element, threshold) {
        let rect = element.getBoundingClientRect().y;
        threshold = threshold ? threshold : 0;

        return rect + threshold < 0
    }



    hide() {
    	this.classList.remove('show-sticky', 'full-sticky', 'animate');

        if (this.inner.style.maxHeight) {
            this.shadowBox.style.display = 'none';
            this.inner.style.maxHeight = null;
        }
    }

    show() {
        this.classList.add('show-sticky', 'animate');
        
        var productUrlDetail = window.location.href;
        if(productUrlDetail.indexOf('product') != -1){
            const sizeCountryBotShow = document.getElementById('measure-size-country-bot');
            if(sizeCountryBotShow?.textContent) {
              $('.footer__content-bottom').css("padding-bottom","122px");
            }else{
              $('.footer__content-bottom').css("padding-bottom","85px");
            }
          }
        // 获取缓存数据sizeList
    //     var localSizeListBot= localStorage.getItem('sizeDataList')!=='undefined' && localStorage.getItem('sizeDataList') 
    //     && localStorage.getItem('sizeDataList').length && JSON.parse(localStorage.getItem('sizeDataList')).filter(item => item.variant_id == sizeId);

    //    if (localSizeListBot && localSizeListBot.length > 0) {
    //         $('.bot-sticky-country').css('display', 'flex');
    //         } else {
    //             $('.bot-sticky-country').css('display', 'none');
    //         }
        }
    toggleEvent(event){
    	event.preventDefault();
        event.stopPropagation();
        
        if (this.inner.style.maxHeight){
            this.inner.style.maxHeight = null;
            this.shadowBox.style.display = 'none';
        } else {
            this.inner.style.maxHeight = `${this.inner.scrollHeight}px`;
            this.shadowBox.style.display = 'block';
        }

    	this.classList.toggle('full-sticky');
    }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);